import script from "./rn-text-control-loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./rn-text-control-loading.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__